import { render } from "./AppQuotaWarning.vue?vue&type=template&id=04f4abb4&scoped=true&ts=true"
import script from "./AppQuotaWarning.vue?vue&type=script&lang=ts"
export * from "./AppQuotaWarning.vue?vue&type=script&lang=ts"

import "./AppQuotaWarning.vue?vue&type=style&index=0&id=04f4abb4&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f4abb4"]])

export default __exports__